import { marqueeWords } from "@/data/content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {marqueeWords.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`whitespace-nowrap px-8 text-5xl font-bold tracking-[-0.03em] sm:text-7xl lg:text-8xl ${i % 2 ? "marquee-outline" : "text-[#05325F]"}`}>{w}</span>
        <svg viewBox="0 0 20 20" className="h-6 w-6 shrink-0 sm:h-8 sm:w-8"><rect x="4" y="4" width="12" height="12" transform="rotate(45 10 10)" fill="#0085B3" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[#E0E8F2] bg-[#F0F5FA] py-10 sm:py-14" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
